import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalEventsManagerService } from '../../../service/global-events-manager.service';
import { HttpErrorComponent } from '../../../http-error/http-error.component';
import { AuthService } from '../../../service/auth.service';
@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css']
})
export class LogoutComponent implements OnInit {

  constructor(private router: Router, private authService: AuthService, private globalEventsManager: GlobalEventsManagerService, private httpError: HttpErrorComponent) { }

  ngOnInit() {
    console.log('LogoutComponent ngOnInit()')
    this.authService.logout();
    localStorage.clear();
    this.router.navigate(['/etusivu']);
  }
  

}



// WEBPACK FOOTER //
// ./src/app/public/auth/logout/logout.component.ts